import {
    REQUEST_BILLING,
    REQUEST_BILLING_FAILURE,
    REQUEST_BILLING_SUCCESS
} from "../../../constant/transaction/BillingConstant";

const initialState = {
    billing: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const billingReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_BILLING:
            return {
                ...state,
                billing: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_BILLING_SUCCESS:
            return {
                ...state,
                billing: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_BILLING_FAILURE:
            return {
                ...state,
                billing: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
